import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  textWrapper: {
    display: 'flex',
    flex: 1,
  },
  iconWrapper: {
    flexDirection: 'row',
    marginRight: 15,
  },
  icon: {
    fontSize: 16,
    marginRight: 8,
    color: cloudLight,
  },
  suffix: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
